import { noop } from "lodash";
import { isCourseSpace, isSpaceMember } from "@/react/helpers/spaceHelpers";
import type { SpaceDateRange } from "@/react/types/AiSummary/SpaceSummary";
import type { Space, SpaceViewType } from "@/react/types/Space";
import { NotSpaceMemberActions } from "./NotSpaceMemberActions";
import { SpaceMemberActions } from "./SpaceMemberActions";

interface SpaceHeaderActionsProps {
  activeViewType?: SpaceViewType;
  onSummarizeClick?: (range: SpaceDateRange) => void;
  onViewTypeChange?: (viewType: SpaceViewType) => void;
  shouldShowChatRailbar?: boolean;
  space: Space;
  toggleChatRailbar?: () => void;
}

export const SpaceHeaderActions = ({
  space,
  shouldShowChatRailbar = false,
  toggleChatRailbar = noop,
  onViewTypeChange = noop,
  activeViewType,
  onSummarizeClick = noop,
}: SpaceHeaderActionsProps) => {
  if (!isSpaceMember(space) || isCourseSpace(space)) {
    return <NotSpaceMemberActions space={space} />;
  }

  return (
    <SpaceMemberActions
      space={space}
      shouldShowChatRailbar={shouldShowChatRailbar}
      toggleChatRailbar={toggleChatRailbar}
      onViewTypeChange={onViewTypeChange}
      activeViewType={activeViewType}
      onSummarizeClick={onSummarizeClick}
    />
  );
};
